import { gwc_qs, gwc_qsa, gwc_delegate, gwc_on, gwc_parent, gwc_find, gwc_attr, CustomEvent, gwc_updateCartByCheckout } from '../modules/give-wc-helpers';
import { Give_WC_Amount } from '../modules/give-wc-amount';

/**
 * All the actions related to the Give Donation form will be done in this.
 *
 * @since 1.0.0
 */
export default class Give_WC_Donation_Form {

    /**
     * Constructor.
     */
    constructor() {

        // Get WooCommerce panel.
        this.$wcPanel = gwc_qs('body.woocommerce-cart, body.woocommerce-checkout');

        // Get the head of the donation form.
        this.$donationHead = 'input[type="checkbox"].give-wc-form-selector, .give-wc-give-form-head,.give-wc-checkbox-row';

        // Get the donation form levels.
        this.$donationLevel = 'input[type="radio"].give-wc-donation-level, select.give-wc-select';

        // Donation form amount field.
        this.$amount_field = 'input.give-wc-amount-field';

        // Get the checkout button.
        this.$checkoutButton = 'a.checkout-button';

        // If we're not the cart/checkout page.
        if (null !== this.$wcPanel && null !== gwc_qs('.give_wc_donation_section')) {
            this.bindEvents();
        }

        // Fix cart list when hit back button on checkout page.
        this.fixCartWhenHitBack();
    }

    /**
     * When come back from the checkout page to cart page reset the donation form list.
     *
     * @since 1.0.0
     */
    fixCartWhenHitBack() {
        if (
            window.performance
            && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD
        ) {
            // Get all checkbox.
            let donationCheckboxs = gwc_qsa('input.give-wc-form-selector');

            donationCheckboxs.forEach((element) => {
                // Uncheck.
                element.checked = false;

                const
                    donationRow = gwc_parent(element, 'td'),
                    donationOptions = gwc_qs('.give-wc-donation-inside', donationRow);

                donationRow.classList.remove('give-wc-active-row');
                donationOptions.classList.add('give-wc-hidden');
            });
        }
    }

    /**
     * Bind events callbacks with selectors.
     *
     * @since 1.0.0
     */
    bindEvents() {
        let that = this;

        /**
         * Disable the default behaviour of the checkbox and label.
         */
        gwc_delegate(that.$wcPanel, '.give-wc-give-form-label input, .give-wc-give-form-label p', 'click', (e) => {
            e.stopPropagation();
        });

        /**
         * Update Cart on click.
         */
        gwc_delegate(that.$wcPanel, '.woocommerce-checkout button[name="give_wc_update_donation"]', 'click', (e) => {
            document.body.dispatchEvent(new CustomEvent('update_checkout')); // Dispatch it.
        });

        /**
         * When amount field updated.
         */
        gwc_delegate(that.$wcPanel, that.$amount_field, 'change', (e) => {

            // Set amount.
            let amountField = e.target,
                amount = new Give_WC_Amount(amountField.value);

            // Format the amount.
            amountField.value = amount.formatAmount();

            let matchLevel,
                parentRow = gwc_parent(amountField, 'td'),
                formID = parentRow.getAttribute('data-form_id'),
                unformatAmount = amount.unFormatAmount();

            // Check min/max amount.
            !new Give_WC_Amount(unformatAmount).verifyAmount(formID) ? amountField.classList.add('give-wc-invalid-amount') : amountField.classList.remove('give-wc-invalid-amount');

            // Get the donation levels.
            let donationLevels = gwc_qsa('select.give-wc-select option, input[type="radio"].give-wc-donation-level', parentRow);

            // If donation form has variable prices.
            if (donationLevels.length > 0) {

                // Go through each of the donation levels.
                Array.prototype.forEach.call(donationLevels, (node) => {
                    if (unformatAmount == node.getAttribute('data-amount')) {
                        matchLevel = node.value;
                        return;
                    }
                });

                // Get the match level.
                matchLevel = ('undefined' === typeof matchLevel) ? 'custom' : matchLevel;

                // Auto choose the donation level.
                switch (give_wc_vars.level_display_style) {

                    case 'dropdown':
                        gwc_qs('.give-wc-select', parentRow).value = matchLevel;
                        break;
                    case 'radio':
                        gwc_qs('.give_wc_level_' + matchLevel, parentRow).checked = true;
                        break;
                }
            }
        });

        /**
         * Toggle Donation Form options.
         */
        gwc_delegate(that.$wcPanel, that.$donationHead, 'click', (e) => {

            // Get the donation row td.
            let
                selectedHead = e.target,
                donation_row = gwc_parent(selectedHead, 'td'),
                amount_field = gwc_qs('.give-amount-top', donation_row);

            // Add/Remove class.
            donation_row.classList.toggle('give-wc-active-row');

            if ('INPUT' !== selectedHead.nodeName) {

                // Donation form checkbox.
                let form_checkbox = gwc_qs('input[type="checkbox"].give-wc-form-selector', donation_row);

                // Toggle the checkbox.
                form_checkbox.checked = form_checkbox.checked ? false : true;
            }

            // Toggle the donation option.
            gwc_find(donation_row, 'give-wc-donation-inside').classList.toggle('give-wc-hidden');

            // Verify amount.
            new Give_WC_Amount(amount_field.value).verifyAmount(donation_row.getAttribute('data-form_id'));
        });

        /**
         * When Donation level changed.
         */
        gwc_delegate(that.$wcPanel, that.$donationLevel, 'change', (e) => {
            e.preventDefault();

            let currentLevel = e.target,
                parentRow = gwc_parent(currentLevel, 'td'),
                formInsider = gwc_find(parentRow, 'give-wc-donation-inside'),
                amountField = gwc_qs('.give-amount-top', parentRow);

            // Get the donation amount and price Id.
            let donationAmount = ('SELECT' === currentLevel.nodeName) ? currentLevel.options[currentLevel.selectedIndex].getAttribute('data-amount') : currentLevel.getAttribute('data-amount');
            let priceID = ('SELECT' === currentLevel.nodeName) ? currentLevel.options[currentLevel.selectedIndex].value : currentLevel.value;

            // Set the formatted value.
            amountField.value = '' !== donationAmount ? new Give_WC_Amount(donationAmount).formatAmount() : 0.00;

            if ('custom' === priceID) {
                // Highlights amount field for better UI.
                amountField.setSelectionRange(0, 5);
                amountField.focus();
            }


            // Update the text of the amount span.
            if (gwc_qs('.give-wc-form-amount', formInsider)) {
                gwc_qs('.give-wc-form-amount', formInsider).innerText = new Give_WC_Amount(donationAmount, { symbol: give_wc_vars.currency_settings.symbol }).formatAmount();
            }

            !new Give_WC_Amount(amountField.value).verifyAmount(parentRow.getAttribute('data-form_id'))
                ? amountField.classList.add('give-wc-invalid-amount')
                : amountField.classList.remove('give-wc-invalid-amount');
        });

        /**
         * When click on the "Proceed to checkout" add selected donation to the WC Cart.
         *
         * @since 1.0.0
         */
        gwc_delegate(that.$wcPanel, that.$checkoutButton, 'click', (e) => {
            e.preventDefault();
            gwc_updateCartByCheckout('give_wc_process_donations', gwc_qs('.woocommerce-cart-form'));
        });

    }

}



// WEBPACK FOOTER //
// ./assets/src/js/frontend/give-wc-form.js